export const DAlignVertical = wcardinal.ui.DAlignVertical;